import { render, staticRenderFns } from "./PresetPassi.vue?vue&type=template&id=f6a59674&"
import script from "./PresetPassi.vue?vue&type=script&lang=js&"
export * from "./PresetPassi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports